import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../_services/dashboard.service';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import * as FILESAVER from 'file-saver';
import * as moment from 'moment';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-students-dismissal-tracking',
  templateUrl: './students-dismissal-tracking.component.html',
  styleUrls: ['./students-dismissal-tracking.component.scss']
})
export class StudentsDismissalTrackingComponent implements OnInit, OnDestroy {
  loading = true;
  reportFilter;
  readyToPickup;
  readyTillReceived;
  dismissalProcess;

  dismissalStatistics: any = {};
  sub: Subscription;
  printSub: Subscription;
  currLang;
  @Output() stopLoading = new EventEmitter();

  constructor(
    private router: Router,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dashboardService: DashboardService) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.sub = new Subscription();
    this.printSub = new Subscription();
    // this.dashboardService.subScribeToChannel(`dashboardDismissalTracking_${localStorage.getItem('schoolId')}`, `App\\Events\\DashboardDismissalTracking`, (data) => {
    //   if (localStorage.getItem("date") == moment(new Date()).format('YYYY-MM-DD')) {
    //     this.updateDashboardDismissalTrackingData(data);
    //   }
    // });
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.printSub.unsubscribe();
  }

  ngOnInit(): void {
    let date = localStorage.getItem("date");
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.getDismissalReport(date ? date : moment(new Date()).format('YYYY-MM-DD'));
    let x = this.dashboardService.getReportFilter().subscribe((res: any) => {
      if (res !== null) {
        this.reportFilter = res;
        this.getDismissalReport(this.reportFilter.toDate);
      }
    })
    this.sub.add(x);

    let p = this.dashboardService.getDownloadData().subscribe((res: any) => {
      if (res && (this.router.url.split('/')[2] === 'dismissal-tracking')) {
        let workBook = XLSX.utils.book_new();
        workBook.SheetNames.push('test sheet');
        let valuesToBeExported = [];

        valuesToBeExported.push(
          {
            'Students not Requested': (this.dismissalStatistics.not_requested),
            'Students Getting Ready': (this.dismissalStatistics.get_ready),
            'Students with Staff': (this.dismissalStatistics.with_staff),
            'Students Delivered': (this.dismissalStatistics.delivered),
          })
        let ws_Data = valuesToBeExported;
        let ws = XLSX.utils.json_to_sheet(ws_Data);
        workBook.Sheets['test sheet'] = ws;
        let workBookOut = XLSX.writeFile(workBook, 'book.xlsx');

        function s2ab(s) {
          let buf = new ArrayBuffer(s.length);
          let view = new Uint8Array(buf);
          for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
          return buf;
        }
        $("#button-a").click(function () {
          FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
        });
      }
    })
    this.printSub.add(p);
  }
  getDismissalReport(date) {
    this.dashboardService.getDismissalTrackingStatistics(date).subscribe((res: any) => {
      this.dismissalStatistics = res;
      this.stopLoading.emit();
      this.loading = false;
    })
  }
  updateDashboardDismissalTrackingData(data) {
    this.dismissalStatistics = data;
  }
  openDismissalReprots() {
    this.dashboardService.setDownloadData(false);
    this.router.navigateByUrl('/reports/dismissal-tracking')
  }

}
